import React, { useMemo } from 'react';

import cs from 'classnames';
import { AgGridReact } from 'ag-grid-react';
import { LicenseManager } from 'ag-grid-enterprise';

import { NATIVE_HEADER_GEOMETRY, applyHeaderMinWidths } from '../AGTable/lib/headerMinWidth';

import '../AGTable/Table.scss';

LicenseManager.setLicenseKey(process.env.REACT_AG_GRID_KEY);

const AGBasicTable = ({
  customClassName,
  columnDefs = [],
  rowData,
  defaultColDef = {},
  gridRef,
  ...props
}) => {
  const sizedColumnDefs = useMemo(
    () => applyHeaderMinWidths(columnDefs, defaultColDef, NATIVE_HEADER_GEOMETRY),
    [columnDefs, defaultColDef]
  );

  return (
    <div className={cs('ag-theme-quartz h-full', customClassName)}>
      <AgGridReact
        ref={gridRef}
        columnDefs={sizedColumnDefs}
        rowData={rowData}
        defaultColDef={defaultColDef}
        {...props}
      />
    </div>
  );
};

export default AGBasicTable;
